<template>
  <div class="px-4">
    <router-link
      class="--no-style block"
      to="/"
      :aria-label="$parent.$t('layout.navigation.returnHome')"
    >
      <img
        alt="Logo Smapshot"
        width="55"
        height="26"
        src="@/assets/images/logos/logo_smapshot_short.svg"
      >
    </router-link>
  </div>
</template>
